export default __webpack_public_path__ + "static/media/twitter_icon_white.699151f2.svg";